import { useSchedulingLayout } from 'app/components/scheduling-layout/useSchedulingLayout'
import { SchedulingLayoutShadcnComponent } from 'app/components/scheduling-layout/SchedulingLayoutShadcnComponent'

export const handle = {
  title: `Scheduling`,
  breadcrumb: `Scheduling`,
}

export default function Scheduling(): React.ReactElement {
  const { children } = useSchedulingLayout()
  return <SchedulingLayoutShadcnComponent>{children}</SchedulingLayoutShadcnComponent>
}
